<template>
    <div class="container" v-loading="tableing">
        <div class="header">
            <el-button class="exit" size="mini" @click="exit()"> 退出 </el-button>
        </div>
        <div class="main">
            <div class="main-clone">
                <!-- 默认版  -->
                <div class="commitment" id="eat" v-if="!tab2TxtGATAccount">
                    <h2 class="ti">中国音乐学院2026年全国硕士研究生招生考试诚信复试承诺书</h2>
                    <div class="ti-nr">
                        <p class="nr textIndent2" style="margin-top: 0px;">本人作为参加中国音乐学院2026年全国硕士研究生招生复试的考生，已充分知悉《中华人民共和国刑法修正案（九）》《国家教育考试违规处理办法》（教育部令第33号）及北京教育考试院、中国音乐学院相关规章制度。为维护国家教育考试的严肃性、公平性与权威性，现郑重承诺如下：</p>
                        <p class="nr textIndent2 fbold">一、思想品德承诺</p>
                        <p class="nr textIndent2">1. 自觉践行社会主义核心价值观，恪守学术道德规范。</p>
                        <p class="nr textIndent2">2. 在复试全过程中展现良好的精神风貌，杜绝任何有损教育公平、违背社会公序良俗的行为。</p>
                        <p class="nr textIndent2 fbold">二、诚信应考承诺</p>
                        <p class="nr textIndent2">1. 确保报考信息及提交的学籍学历、学术科研成果等所有材料真实、完整、有效。如因信息虚假或材料造假导致不能参加考试、录取以及入学后不能进行学籍注册等后果，自愿承担全部法律责任。</p>
                        <p class="nr textIndent2">2. 严格遵守考场规则，服从考试工作人员管理。不携带违禁物品进入考场，不使用任何违规通讯工具或技术手段，不以任何形式实施作弊行为。</p>
                        <p class="nr textIndent2 fbold">三、保密责任承诺</p>
                        <p class="nr textIndent2">1. 严格保守国家教育考试秘密，在复试工作结束前不通过任何途径泄露或传播复试试题、考试流程、评委信息等相关考试内容。</p>
                        <p class="nr textIndent2">2. 不以录音、录像等任何形式记录复试过程，不传播与考试相关的音视频及文字资料。</p>
                        <p class="nr textIndent2 fbold">四、遵纪守法承诺</p>
                        <p class="nr textIndent2">1. 充分知晓研究生招生考试属于法律规定的国家教育考试，如有替考、组织作弊、非法出售试题答案等行为，将依法承担刑事责任。</p>
                        <p class="nr textIndent2">2. 接受并配合学校依据《普通高等学校学生管理规定》（教育部令第41号）开展的入学复查，如发现不符合报考条件或存在弄虚作假情形，自愿接受取消学籍等处理决定。</p>
                        <p class="nr textIndent2 fbold">五、责任追究承诺</p>
                        <p class="nr textIndent2">如有违反上述承诺的行为，本人自愿承担以下后果：</p>
                        <p class="nr textIndent2">1. 立即终止复试或取消录取资格；</p>
                        <p class="nr textIndent2">2. 接受国家教育考试违规处理办法规定的处罚；</p>
                        <p class="nr textIndent2">3. 违纪事实记入国家教育考试诚信档案；</p>
                        <p class="nr textIndent2 marginB15">4. 涉嫌犯罪的，依法移送司法机关处理。</p>
                    </div>
                </div>
                <!-- “港澳台”指定用户展示 (暂时废弃，保留功能)-->
                <div class="commitment" id="eat" v-else>
                    <h2 class="ti">中国音乐学院2026年面向港澳台地区招收研究生考试诚信复试承诺书</h2>
                    <div class="ti-nr">
                        <p class="nr textIndent2" style="margin-top: 0px;">本人作为参加中国音乐学院2026年面向港澳台地区招收研究生考试的考生，已充分知悉《中华人民共和国刑法修正案（九）》《国家教育考试违规处理办法》（教育部令第33号）及中国音乐学院相关规章制度。为维护研究生招生考试的严肃性、公平性与权威性，现郑重承诺如下：</p>
                        <p class="nr textIndent2 fbold">一、思想品德承诺</p>
                        <p class="nr textIndent2">1. 自觉恪守学术道德规范，遵守公序良俗。</p>
                        <p class="nr textIndent2">2. 在考试全过程中展现良好的精神风貌，杜绝任何有损考试公平、违背诚信原则的行为。</p>
                        <p class="nr textIndent2 fbold">二、诚信应考承诺</p>
                        <p class="nr textIndent2">1. 确保报考信息及提交的学籍学历、学术科研成果等所有材料真实、完整、有效。如因信息虚假或材料造假导致不能参加考试、录取以及入学后不能进行学籍注册等后果，自愿承担全部责任。</p>
                        <p class="nr textIndent2">2. 严格遵守考场规则，服从考试工作人员管理。不携带违禁物品进入考场，不使用任何违规通讯工具或技术手段，不以任何形式实施作弊行为。</p>
                        <p class="nr textIndent2 fbold">三、保密责任承诺</p>
                        <p class="nr textIndent2">1. 严格保守国家教育考试秘密，在考试工作结束前不通过任何途径泄露或传播考试试题、考试流程、评委信息等相关考试内容。</p>
                        <p class="nr textIndent2">2. 不以录音、录像等任何形式记录考试过程，不传播与考试相关的音视频及文字资料。</p>
                        <p class="nr textIndent2 fbold">四、遵纪守法承诺</p>
                        <p class="nr textIndent2">1. 充分知晓研究生招生考试属于国家教育考试范畴，如有替考、组织作弊、非法出售试题答案等行为，将依法承担相应责任。</p>
                        <p class="nr textIndent2">2. 接受并配合学校开展的入学复查，如发现不符合报考条件或存在弄虚作假情形，自愿接受取消学籍等处理。</p>
                        <p class="nr textIndent2 fbold">五、责任追究承诺</p>
                        <p class="nr textIndent2">如有违反上述承诺的行为，本人自愿承担以下后果：</p>
                        <p class="nr textIndent2">1. 立即终止考试或取消录取资格；</p>
                        <p class="nr textIndent2">2. 接受国家及学校相关考试违规处理办法规定的处罚；</p>
                        <p class="nr textIndent2">3. 违纪事实记入相关考试诚信档案；</p>
                        <p class="nr textIndent2 marginB15">4. 涉嫌犯罪的，依法移送司法机关处理。</p>
                    </div>
                </div>
                
                <div class="goExamBox">
                    <el-checkbox class="agreeCheckout" v-model="deelAgree" size="medium" :disabled="time10Value>0">本人确认已完整阅读、充分理解并自愿接受上述全部条款，保证以本人真实行为履行考试承诺。 <b v-if="time10Value>0">{{time10Value}}s</b> </el-checkbox>
                    <el-button class="upSub" @click="lastQuestion()" :style="{'background':deelAgree?'':'#cdcbcb'}"> 下一步 </el-button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { getDateNow } from '../../lib/youxunAPI';
import util from '../../lib/util'
    export default {
        name:"mkfDetection",
        data() {
            return {
                tableing:false,
                deelAgree:false,
                timer10:null,
                time10Value:10,
                locName:'',
                tab2TxtGATAccount:false,
            }
        },
        components:{},
        watch: {
            'deelAgree':function(now,old){
                this.updateAgreementLocal(now)
            }
        },
        computed:{},
        created(){},
        beforeDestroy() {
            this.timer10 && clearTimeout(this.timer10)
        },
        mounted(){
            this.locName = `gyAm-${Number(this.$base64.decode(window.localStorage.getItem('uid-web')))}`
            const agreeLocValue = window.localStorage.getItem(this.locName)?JSON.parse(window.localStorage.getItem(this.locName)):''
            if(this.$route.query.tab2TxtGATAccount)
            this.tab2TxtGATAccount = String(this.$route.query.tab2TxtGATAccount)=='true'?true:false
            if(!agreeLocValue || !agreeLocValue[this.$route.query.bId]){
                // 阅读10s倒计时
                this.set10s()
            }else{
                this.time10Value = 0
                this.deelAgree = true
            }
        },
        methods:{
            // 同步localStorage 勾选状态，ps:true保存 false删除
            updateAgreementLocal(flag){
                let agreeLoc = window.localStorage.getItem(this.locName)
                if(!agreeLoc){
                    if(flag){
                        let s = {}
                        s[this.$route.query.bId] = flag
                        window.localStorage.setItem(this.locName,JSON.stringify(s))
                    }
                    return
                }
                agreeLoc = JSON.parse(agreeLoc)
                if(!agreeLoc[this.$route.query.bId]){
                    if(flag){
                        agreeLoc[this.$route.query.bId] = flag
                    }
                }else{
                    if(!flag){
                        delete agreeLoc[this.$route.query.bId]
                    }
                }
                if(JSON.stringify(agreeLoc)=='{}')
                window.localStorage.removeItem(this.locName)
                else
                window.localStorage.setItem(this.locName,JSON.stringify(agreeLoc))
            }, 
            set10s(){
                this.time10Value = this.$options.data().time10Value
                this.timer10 && window.clearTimeout(this.timer10)
                this.set10sreadItem()
            },
            set10sreadItem(){
                let that = this
                that.timer10  = window.setTimeout(function(){
                    if(that.time10Value <= 0){
                        window.clearTimeout(that.timer10)
                    }else{
                        that.time10Value--;
                        that.set10sreadItem()
                    }
                },1000) 
            },
            lastQuestion(){
                if(!this.deelAgree){
                    this.$message.error('请勾选已阅读并同意以上条款')
                    return
                }   
                let href_ = window.location.href.split('#/')[1]
                let lv = href_.indexOf('?')!=-1? href_.split('?')[0]:''
                let menuListArr = this.$route.query.menuList.split(',')
                let menuListLoc = menuListArr.indexOf(String(util.menuListGet().indexOf(lv)))
                this.$router.push({
                    path: `/${util.menuListGet()[menuListArr[menuListLoc+1]]}`,
                    query: {
                        bId:this.$route.query.bId,
                        paperName:this.$route.query.paperName,
                        userSignId:this.$route.query.userSignId,
                        ticketNum:this.$route.query.ticketNum,
                        idName:this.$route.query.idName,
                        idCardNo:this.$route.query.idCardNo,
                        youXunExamId:this.$route.query.youXunExamId,
                        youXunExamNum:this.$route.query.youXunExamNum,
                        examStartDate:this.$route.query.examStartDate,
                        examEndDate:this.$route.query.examEndDate,
                        examStatus:this.$route.query.examStatus,
                        examStartDateVal:this.$route.query.examStartDateVal,
                        examEndDateVal:this.$route.query.examEndDateVal,
                        examMin:this.$route.query.examMin,
                        personNum:this.$route.query.personNum,
                        reviewType:this.$route.query.reviewType,
                        menuList:this.$route.query.menuList,
                        bohuiChongchuan:this.$route.query.bohuiChongchuan,
                    }
                }) 
            },
            exit(){
                this.$confirm('请问是否退出当前页面？','确认信息',{
                    distinguishCancelAndClose:true,
                    confirmButtonText:'是',
                    cancelButtonText:'否',
                })
                .then(()=>{
                    if(sessionStorage.getItem('orgId')){//测评
                        this.$router.push({
                            path: `/${sessionStorage.getItem('orgId')}/examList`,
                        })
                    }else{
                        this.$router.push({
                            path: '/myExamList'
                        })
                    }
                })
                .catch((action)=>{})
            },
        }
    }
</script>
<style scoped lang="less">
    .container{
        width: 100%;
        height: 100%;
        min-height: 560px;
        overflow: auto;
        position: relative;
    }
    .header{
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        height: 60px;
        line-height: 60px;
        text-align: center;
        font-size: 19px;
        font-weight: bold;
        color: #000;
        border-bottom: 1px solid #EDEEED;
        .exit{
            background-color: #31C4FE;
            border: none;
            font-size: 15px;
            width: 74px;
            height: 32px;
            color: #fff;
            position: absolute;
            top: 15px;
            right: 3%;
            img{
                height: 10px;
            }
        }
    }
    .main{
        position: absolute;
        top: 75px;
        bottom: 0;
        left: 0;
        right: 0;
        width: 100%;
        .main-clone{
            height:100%;
            width: 100%;
            overflow: hidden;
            position: relative;
            
            .commitment{
                position: absolute;
                top: 0%;
                left: 7%;
                right: 7%;
                bottom: 20%;
                .ti{
                    height: 50px;
                    color: #000;
                    margin: 0;
                    text-align: center;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                }
                .ti-nr{
                    position: absolute;
                    top: 50px;
                    left: 0;
                    right: 0;
                    bottom: 0rem;
                    overflow-y: auto;
                    font-size: 18px;
                    color: #000;
                    font-weight: 500;
                    .nr{ 
                        color: #6C6D6C;
                        text-align: left;
                        margin: 7px 0;
                    }
                    .textIndent2{
                        text-indent:34px;
                    }
                    .fbold{
                        color: #000;
                        font-weight: bold;
                    }
                    .marginB15{
                        margin-bottom: 15px;
                    }
                }
            }
            
            .goExamBox{
                position: absolute;
                left: 0;
                right: 0;
                bottom: 0;
                height: 20%;
                width: 100%;
                // position: relative;
                .agreeCheckout{
                    b{
                        font-size: 20px;
                        color: red;
                        margin-left: 10px;
                    }
                }
                .upSub{
                    position: absolute;
                    left: 0;
                    top: 0;
                    right: 0;
                    bottom: 0;
                    margin: auto;
                    height: 45px;
                    width: 35%;
                    background: rgb(0, 75, 180);
                    color: #FFF;
                    border-radius: 3px;
                    font-size: 18px;
                    border:none;
                }
            }
        }
    }
</style>
<style>
    #scan-qr-gy > img{
        height: 100%;
        width: 100%;
    }
    .agreeCheckout.el-checkbox .el-checkbox__inner{
        height: 20px;
        width: 20px;
    }
    .agreeCheckout.el-checkbox .el-checkbox__label{
        font-size: 17px;
    }
</style>



// WEBPACK FOOTER //
// src/pages/myExamList/signCommitment.vue